import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import classes from "./dropDown.module.css";

import { ChevronRightIcon } from "@heroicons/react/24/outline";


const Dropdown = ({ id, title, activeMenu, setActiveMenu }) => {
  const isActive = activeMenu === id;

  const handleClick = () => {
    setActiveMenu(prev => (prev === id ? null : id));
  };

  return (
    <div
      className={`${classes.dropdownRow} ${
        isActive ? classes.active : ""
      }`}
      onClick={handleClick}
    >
      <span className={classes.dropDownRow__title}>{title}</span>
      <ChevronRightIcon
        className={`${classes.arrow} ${isActive ? classes.arrowOpen : ""}`}
      />
    </div>
  );
};

export default Dropdown;
